import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'

import { Empresa } from '../../pkw-data/core/empresa.model'
import { EmpresaService } from '../services/empresa.service'

@Injectable()
export class EmpresasAtivasResolver implements Resolve<Empresa[]> {
    constructor(private empresaService: EmpresaService) {}

    resolve() {
        return this.empresaService.obterAtivas()
    }
}



// WEBPACK FOOTER //
// ./src/app/core/resolvers/empresas-ativas.resolver.ts